import s from '../collegesItem.module.css'
import {useState} from "react";
import {useAddAlert} from "@/hooks/useAddAlert";
import {usersAPI} from "@api"
import { InputNew } from "@UI/InputNew";
import {CheckBoxLabel} from "@UI/CheckBox";
import {Button} from "antd";

const ModalRecoverPassword = ({setActive, userId}) => {
  const addAlert = useAddAlert();

  const [loading, setLoading] = useState(false);
  
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);
  const [customPassword, setCustomPassword] = useState(false);
  const [newPassword, setNewPassword] = useState(null);

  const save = () => {
    setActive(false)
  };

  const recover = () => {
    setLoading(true)
    usersAPI.resetPassword({ id: userId, data: {custom_password: customPassword, password: newPassword }})
    .then((res) => {
        setStatus(res?.data?.status ?? res?.response?.data?.status);
        setError(res?.data?.error ?? (res?.response?.data?.error ?? null))
    })
    .finally(()=>{
        setLoading(false)
    })
  };
    
  return <div className="modal_departments">
    <h2 className="modal__title">Восстановить пароль</h2>
    <div className={s.body}>
            <CheckBoxLabel
                    style={{marginRight: 'auto', paddingLeft:'0px'}}
                    value={customPassword}
                    onClick={() => setCustomPassword((state)=> !state)}
                    label='Задать новый пароль вручную'
            />
            {customPassword && <InputNew
                title={'Введите новый пароль'}
                style={{width:'100%'}}
                onChange={(e) => setNewPassword(e.target.value)}
            ></InputNew>}
            <p>
            {status === null ? "Нажмите кнопку отправить для сброса пароля" :
                (status === 'error'
                    ? (error ?? "Невозможно сбросить пароль")
                    : "Пароль успешно сброшен. Новый пароль отправлен на почту.")
            }
            </p>
            
            {status ? (
                <Button disabled={loading} onClick={save}>Хорошо</Button>
            ) : (
            <>
                <Button disabled={loading} onClick={recover}>Отправить</Button>
                <Button disabled={loading} onClick={save}>Отмена</Button>
            </>
            )}
    </div>
  </div>
}
export default ModalRecoverPassword;